<div class="main-content">
  <app-header [title]="'HEADER.TITLE_NEW_TICKET' | translate" [subtitle]="'HEADER.SUBTITLE_NEW_TICKET' | translate" />

  <div class="row pt-5 mt-4 mt-md-0">
    <div class="col-12">
      @if (!showSuccess && !showError) {
        <app-icam-container [centralIcon]="true" [iconName]="'ticket'" [iconColor]="'#e30714'" [iconHeight]="'32px'">
          <form
            class="form-container ticket-form d-flex flex-column flex-md-row"
            [formGroup]="form"
            (ngSubmit)="submitForm()"
          >
            <!-- {{ form.value | json }} -->
            <div class="form-section personal-info-section w-100">
              <div class="d-flex align-items-center form-title" [ngClass]="isLight ? 'light' : 'dark'">
                <div class="d-flex align-items-center p-2">
                  <img class="section-image" src="../../assets/icon/user.svg" alt="user" />
                </div>
                <div class="form-title-text-container">
                  <p class="my-0 py-0" [ngClass]="isLight ? 'light' : 'dark'">
                    {{ 'PERSONAL_INFO_FORM.PERSONAL_INFORMATION' | translate }}
                  </p>
                </div>
              </div>
              <div class="input-wrapper">
                <label for="name"> {{ 'PERSONAL_INFO_FORM.NAME' | translate }}*</label>
                <app-icam-input
                  label="{{ 'PERSONAL_INFO_FORM.NAME' | translate }}"
                  inputId="name"
                  [isSlim]="true"
                  [required]="true"
                  formControlName="firstName"
                  [ngClass]="isLight ? 'light' : 'dark'"
                />
              </div>
              <div class="input-wrapper">
                <label for="last_name">{{ 'PERSONAL_INFO_FORM.LAST_NAME' | translate }}*</label>
                <app-icam-input
                  label="{{ 'PERSONAL_INFO_FORM.LAST_NAME' | translate }}"
                  inputId="last_name"
                  [formControlName]="'lastName'"
                  [isSlim]="true"
                  [required]="true"
                  [ngClass]="isLight ? 'light' : 'dark'"
                />
              </div>
              <div class="input-wrapper">
                <label for="email">Email*</label>
                <app-icam-input
                  label="Email"
                  inputId="email"
                  [formControlName]="'email'"
                  [isSlim]="true"
                  inputType="email"
                  [required]="true"
                  [ngClass]="isLight ? 'light' : 'dark'"
                />
              </div>
              <div class="input-wrapper">
                <label for="phone">{{ 'PERSONAL_INFO_FORM.PHONE' | translate }}</label>
                <app-icam-input
                  label="{{ 'PERSONAL_INFO_FORM.PHONE' | translate }}"
                  inputId="phone"
                  [isSlim]="true"
                  inputType="tel"
                  [formControlName]="'phone'"
                  [required]="false"
                />
              </div>
              <div class="input-wrapper">
                <p class="required-info">*{{ 'PERSONAL_INFO_FORM.REQUIRED' | translate }}</p>
              </div>
            </div>
            <div class="form-section access-info-section w-100">
              <div class="d-flex align-items-center form-title" [ngClass]="isLight ? 'light' : 'dark'">
                <div class="d-flex align-items-center p-2">
                  <img class="section-image" src="../../assets/icon/headset.svg" alt="headset" />
                </div>
                <div class="form-title-text-container">
                  <p class="my-0 py-0" [ngClass]="isLight ? 'light' : 'dark'">
                    {{ 'PERSONAL_INFO_FORM.PERSONAL_TICKET' | translate }}
                  </p>
                </div>
              </div>
              <div class="input-wrapper">
                <div class="form-group">
                  <label for="mySelect">{{ 'PERSONAL_INFO_FORM.NUMBER' | translate }}*</label>
                  <app-icam-autocomplete-select
                    id="mySelect"
                    formControlName="serialNumber"
                    [placeholder]="'COMMON.CHOOSE_VALUE' | translate"
                    [options]="serialNumberOptions"
                    [displayField]="'name'"
                    [valueField]="'id'"
                    [filterFields]="['name']"
                    [required]="true"
                    [fetchFn]="fetchSerialNumbers"
                  ></app-icam-autocomplete-select>
                </div>
              </div>
              <div class="input-wrapper">
                <div class="form-group">
                  <label for="error_code">{{ 'TICKET.ERROR_CODE' | translate }}</label>
                  <!-- Input con autocomplete dropdown custom -->
                  <div class="autocomplete-wrapper">
                    <input
                      id="error_code"
                      type="text"
                      class="form-control rounded-0 slim"
                      [ngClass]="isLight ? 'light' : 'dark'"
                      formControlName="errorMessage"
                      placeholder="{{ 'TICKET.ERROR_CODE_PLACEHOLDER' | translate }}"
                      autocomplete="off"
                      (input)="onErrorCodeInput($event)"
                      (focus)="onErrorCodeFocus()"
                      (blur)="onErrorCodeBlur()"
                      (keydown.enter)="onErrorCodeEnter($event)"
                    />
                    @if (showDropdown && filteredErrorCodes.length > 0) {
                      <ul class="autocomplete-dropdown" [ngClass]="isLight ? 'light' : 'dark'">
                        @for (code of filteredErrorCodes; track code.dec) {
                          <li
                            class="autocomplete-item"
                            (mousedown)="selectErrorCode(code.dec)"
                          >
                            {{ code.dec }}
                          </li>
                        }
                      </ul>
                    }
                  </div>
                </div>
              </div>
              <div class="input-wrapper">
                <label for="description">{{ 'PERSONAL_INFO_FORM.DESCRIPTION' | translate }}</label>
                <textarea
                  label="description"
                  inputId="error_code"
                  class="w-100"
                  [formControlName]="'description'"
                  rows="6"
                  placeholder="{{ 'PROBLEM_DESCRIPTION_PLACEHOLDER' | translate }}"
                  [maxlength]="MAXLENGTH_TEXTAREA"
                ></textarea>
                <p class="char-counter">{{ form.get('description')?.value.length || 0 }} / {{ MAXLENGTH_TEXTAREA }}</p>
              </div>
              <div class="d-flex align-items-center gap-2">
                <label for="file-upload" class="custom-file-upload" [ngClass]="isLight ? 'light' : 'dark'">
                  <!-- <img src="../../assets/icon/attachment.svg" alt="Icona Allega File" /> -->
                  <app-icam-icon iconName="attachment" />
                  {{ 'PERSONAL_INFO_FORM.ATTACHMENT' | translate }}
                </label>
                <div
                  class="popover-trigger"
                  ngbPopover="{{ 'acceptedFiles' | translate }}{{ 'docs' | translate }}"
                  triggers="mouseenter:mouseleave"
                  popoverClass="icam-popover {{ isLight ? 'light' : 'dark' }}"
                >
                  <app-icam-icon [iconName]="'info-circle'" />
                </div>
              </div>
              <input
                id="file-upload"
                type="file"
                (change)="onFileSelect($event)"
                style="display: none"
                accept=".jpeg, .jpg, .png, .pdf, .doc, .docx, .xls, .xlsx, .odt, .ods"
              />
              @if (this.form.value.attachmentFileName) {
                <p class="text-muted">
                  {{ form.value.attachmentFileName }}
                  <small
                    class="text-decoration-underline"
                    role="button"
                    (click)="onResetUpdateFile()"
                    (keydown.enter)="onResetUpdateFile()"
                    tabindex="0"
                  >
                    ({{ 'REMOVE' | translate }})
                  </small>
                </p>
              }
              <!-- <button type="submit" class="btn btn-danger mt-4 btn-block">{{ 'TICKET.NEW_TICKET' | translate }}</button> -->
              <button
                type="submit"
                class="button-form-submit"
                [class.disabled]="!form.valid || isLoading"
                [disabled]="!form.valid || isLoading"
              >
                @if (isLoading) {
                  <div class="d-flex justify-content-center">
                    <div class="spinner-border" role="status"></div>
                  </div>
                } @else {
                  {{ 'TICKET.NEW_TICKET' | translate }}
                }
              </button>
            </div>
          </form>
        </app-icam-container>
      }
      @if (showSuccess) {
        <app-icam-container [centralIcon]="true" [iconName]="'ticket'" [iconColor]="'#00A5A9'" [iconHeight]="'32px'">
          <div class="central-content w-100">
            <!-- Contenuto centrale -->
            <h1 class="ticket-title-success mt-5">
              {{ 'TICKET.OPENED_TICKET' | translate }}
            </h1>
            <p class="ticket-subtitle my-5">
              {{ 'TICKET.OPENED_TICKET_DESCRIPTION' | translate }}
            </p>
            <p class="ticket-id">ID TICKET: {{ newTicket?.caseNumber }}</p>
            <p class="ticket-subtitle">
              {{ 'TICKET.READY_IN_60' | translate }}
            </p>
            <div class="d-flex justify-content-center mt-5">
              <app-back-button [linkText]="'TICKET.BACK_TO_NEW_TICKET'" (click)="goBack()" />
            </div>
          </div>
        </app-icam-container>
      }

      @if (showError) {
        <app-icam-container [centralIcon]="true" [iconName]="'ticket'" [iconColor]="'#e30714'" [iconHeight]="'32px'">
          <div class="central-content w-100">
            <!-- Contenuto centrale -->
            <h1 class="ticket-title-error">
              {{ 'TICKET.OPENED_TICKET_ERROR' | translate }}
            </h1>
            <p class="ticket-subtitle my-5">
              {{ 'TICKET.OPENED_TICKET_DESCRIPTION_ERROR' | translate }}
            </p>
            <div class="d-flex justify-content-center mt-5">
              <app-back-button [linkText]="'TICKET.BACK_TO_NEW_TICKET'" (click)="goBack()" />
            </div>
          </div>
        </app-icam-container>
      }
      @if (!showSuccess && !showError) {
        <div class="mt-4">
          <app-back-button [linkText]="'TICKET.BACK_TO_TICKET'" (click)="goBack()" />
        </div>
      }
    </div>
  </div>
</div>
<app-footer-copyright />
